<template>
<div :class="$style['default-package-dialog']">
    <el-dialog :visible="dialogVisible" :title="dialogTitle" @close="cancel">
        <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-label']" ref="table">
            <wt-table :list="tableData" :labels="tableLabels" >
                 <el-table-column slot="before" label="" width="50">
                    <template  slot-scope="scope">
                        <el-radio v-model="selectIndex" :label="scope.row.index" :class="$style['meal-list-radio']" @change="selectMealRow(scope.row)"></el-radio>
                    </template>
                </el-table-column>
            </wt-table>
        </wt-paged-table>
        <div class="button-div">
          <el-button type="primary" @click="submit">选择</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
import { defaultPackageLabels } from './default-package-options'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 8
    },
    defaultBasePackageId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      tableLabels: defaultPackageLabels,
      selectIndex: '',
      page: 0
    }
  },
  watch: {
    page (val) {
      this.selectIndex = ''
    }
  },
  methods: {
    selectMealRow (data) {
      this.select_row = data
    },
    submit () {
      this.$emit('selectDefaultList', this.select_row)
    },
    cancel () {
      this.$emit('close')
    },
    getTableData (page, next) {
      this.page = page
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        example: {
          packageType: 'DEFAULT_WHOLE_GENOM'
        }
      }
      this.$store.dispatch('getPackageList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        this.tableData.forEach((item, index) => {
          if (item.id === this.defaultBasePackageId) {
            this.selectIndex = index
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取基础套餐列表失败')
        this.$refs.table.showReTry()
      })
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.default-package-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
    :global
    .el-radio__inner{
        border:1px solid @mainColor;
        border-radius:50%
    }
}
</style>
